export const genBaseTableConfig = (contentType) => ({
    tableConfig: {
      rowIdPath: "_id",
      // minWidth: '2000px',
      contentType,
      cellData: [],
    },
  });